import React, {useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {FaTimes} from 'react-icons/fa'
import ReactPlayer from 'react-player/vimeo'

function ViewVideo({show, onHide, videoLink}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      backdrop='static'
      backdropClassName='custom-backdrop'
      contentClassName='custom-modal-content'
    >
      <div className='player-wrapper position-relative ms-auto me-auto'>
        <ReactPlayer
          className='react-player'
          width='720px'
          height='480px'
          url={videoLink}
          controls={true}
        />
        <div
          style={{position: 'absolute', top: '20px', left: '5px', cursor: 'pointer'}}
          onClick={onHide}
        >
        <FaTimes
            style={{
              color: 'black',
              cursor: 'pointer',
              fontSize: '18px',
              background: 'white',
            }}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ViewVideo
